import { render } from "./factures.vue?vue&type=template&id=5f465f25"
import script from "./factures.vue?vue&type=script&lang=ts"
export * from "./factures.vue?vue&type=script&lang=ts"
script.render = render

export default script